import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["height", "isLoadingPlaceholder", "isSquare", "testId", "width"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import useTestId from '@ori/testid-generator';
import { Products } from '@ori-ui/icons';
import { Background, Root } from "./styles";
import { IMAGE_PLACEHOLDER, IMAGE_PLACEHOLDER_BACKGROUND } from "../../common";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var ImagePlaceholder = function ImagePlaceholder(_ref) {
  var height = _ref.height,
    isLoadingPlaceholder = _ref.isLoadingPlaceholder,
    isSquare = _ref.isSquare,
    testId = _ref.testId,
    width = _ref.width,
    htmlDivElementProps = _objectWithoutProperties(_ref, _excluded);
  var _useTestId = useTestId(),
    getTestId = _useTestId.getTestId;
  return /*#__PURE__*/_jsxs(Root, _objectSpread(_objectSpread({}, htmlDivElementProps), {}, {
    height: height,
    isSquare: isSquare,
    width: width,
    "data-testid": testId !== null && testId !== void 0 ? testId : getTestId(IMAGE_PLACEHOLDER),
    children: [/*#__PURE__*/_jsx(Products, {
      fontSize: "inherit"
    }), isLoadingPlaceholder ? /*#__PURE__*/_jsx(Background, {
      animation: "wave",
      height: "100%",
      variant: "rectangular",
      width: "100%",
      "data-testid": getTestId(IMAGE_PLACEHOLDER_BACKGROUND)
    }) : null]
  }));
};
//# sourceMappingURL=ImagePlaceholder.js.map